import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AdminSearchComponent } from '../../../components/admin/admin.search';
import { fetchAdminCorporationList } from '../../../api/admin.corporation';
import { AdminCorporationTableComp } from './admin.corporation.table';

interface FetchAdminNoticeParams {
  title?: string;
}

interface CorporationDtoRx {
  corporationId: number;
  name: string;
  address: string;
  createdAt: string;
}

const AdminCorporationList = () => {
  const [corporationList, setCorporationList] = useState<
    CorporationDtoRx[] | null
  >(null);
  const [searchParams, setSearchParams] = useState<FetchAdminNoticeParams>({});

  useEffect(() => {
    const getCorporationList = async () => {
      try {
        const response = await fetchAdminCorporationList(searchParams);
        setCorporationList(response);
      } catch (error) {
        console.error(error);
      }
    };

    getCorporationList();
  }, [searchParams]);

  // 검색 필터 값 변경을 처리하는 함수
  const handleSearchChange = (params: FetchAdminNoticeParams) => {
    setSearchParams(params); // 필터 값을 업데이트하여 API 호출을 트리거함
  };
  return (
    <Container>
      <AdminSearchComponent
        handleSearchChange={handleSearchChange}
        searchType="onlyTitle"
      />
      {corporationList ? (
        <AdminCorporationTableComp
          data={corporationList || []}
          setCorporationList={setCorporationList}
        />
      ) : null}
    </Container>
  );
};

export default AdminCorporationList;

// style
const Container = styled.div``;
